// React Component
import React from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// App Component
import { AppLayout, HeaderLayout, ProcessLayout } from '../../layouts'
import { FamlaServices } from '../../services'
import { useAppSelector } from '../../stores'
import { ProcessList, SearchInput } from '../../components'


// interface
import { iProject } from '../../interfaces'
import { useSearch } from '../../utils'
import { iNewDataProcess, iProcess } from '../../components/type'
interface StateType {
    isLoadingProcess: boolean;
    process: any[];
    project: iProject;
    isLoadingProject: boolean
}


const ProcessByFolderView = () => {
    const { id } = useParams();
    const users = useAppSelector((state) => state.auth);
    const { t } = useTranslation();
    const [state, setState] = React.useState<StateType>({
        isLoadingProcess: true,
        isLoadingProject: true,
        process: [],
        project: {} as iProject,
    })

    const { searchQuery, setSearchQuery, searchResults, searchLoad, setFilter } = useSearch(`/process/search/by/project/${id}`);
    const options = [
        { label: "role", value: "ROLE" },
        { label: `${t('words.name')}/${t('words.description')}`, value: "TITLE" }
    ]


    const updateNotificationByProject = async (projectId: string) => {
        try {
            let data = await FamlaServices("api_host", `/notification/project/${projectId}`, "PUT", "", users.access_token);
            if (data.status === 200) {

            } else {

            }
        } catch (e) {
            return false;
        }
    }

    const mappingExistsForProcess = async (processId: string) => {
        try {
            let data = await FamlaServices("api_host", `/mapping/process/${processId}`, "GET", "", users.access_token);
            if (data.status === 200) {
                return data.body?.data.length > 0;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    };

    const deleProcess = async (process_id?: string, sId?: string) => {
        setState(prevState => ({
            ...prevState,
            process: prevState.process.filter((process: any) => process.Process?._id !== process_id)
        }));

        await FamlaServices("api_host", `/process/${process_id}`, "DELETE", "", users.access_token);
    };



    const setProcess = (form: iNewDataProcess) => {
        setState(prev => ({
            ...prev,
            process: prev.process.map(item => {
                if (item.Process._id === form._id) {
                    return {
                        ...item,
                        Process: {
                            ...item.Process,
                            _id: form._id,
                            description: form.description,
                            title: form.title,
                            updated_at: Date.now(),
                        }
                    };
                }
                return item;
            })
        }));
    };


    React.useEffect(() => {

        const loadProcessByFolder = async () => {
            try {
                let data = await FamlaServices("api_host", `/process/project/${id}`, "GET", "", users.access_token);

                if (data.status === 200) {
                    const processes = data.body.data;

                    // Ajouter la propriété hasMapping à chaque process
                    const processesWithMapping = await Promise.all(
                        processes.map(async (process: any) => {
                            const hasMapping = await mappingExistsForProcess(process.Process?._id);
                            return { ...process, hasMapping };
                        })
                    );

                    setState((prev) => ({
                        ...prev,
                        process: processesWithMapping,
                        isLoadingProcess: false,
                    }));
                } else {
                    setState((prev) => ({ ...prev, isLoadingProcess: false }));
                }
            } catch (error: any) {
                setState((prev) => ({ ...prev, isLoadingProcess: false }));
            }
        };


        loadProcessByFolder();

        const loadProjectById = async () => {

            try {
                let data = await FamlaServices("api_host", `/project/by/id/${id}`, "GET", "", users.access_token);
                if (data.status === 200) {
                    const projects = data.body.data
                    setState((prev) => ({ ...prev, project: projects, isLoadingProject: false }));
                }
            } catch (error: any) {
                setState((prev) => ({ ...prev, error: error.message }));
            }
        }

        loadProjectById();

        const loadNotificationByProject = async (projectId: string) => {
            try {
                let data = await FamlaServices("api_host", `/notification/project/by/id/${projectId}`, "GET", "", users.access_token);
                if (data.status === 200) {
                    const datas = data.body.data
                    if (datas || datas !== null) {
                        updateNotificationByProject(projectId)
                    } else {

                    }
                } else {
                    return
                }
            } catch (e) {
                return;
            }
        };

        loadNotificationByProject(id ?? "")

    }, [id, users.access_token])


    return (
        <AppLayout>
            <>
                <HeaderLayout
                    loadcompany={false}
                    search={true}
                    searchfilter={true}
                    setFilter={setFilter}
                    setSearchQuery={setSearchQuery}
                />
                <div className="container-fluid mt-3 pb-3 px-3 w-100">
                    <ProcessLayout
                        title={searchQuery === "" ? `${state.project.title && state.project.title}` : `${t('words.searching')}...${searchQuery}`}
                        arrowBack={state.project.title ? true : false}
                        style={{ height: 'auto', width: "100%" }}
                        addClassName='overflow-auto w-100 controleScroll tableProcess '

                    >
                        <ProcessList
                            isLoading={state.isLoadingProcess}
                            list={state.process}
                            t={t}
                            searchResults={searchResults}
                            searchQuery={searchQuery}
                            searchLoad={searchLoad}
                            deleProcess={deleProcess}
                            setProcess={setProcess}
                        />
                    </ProcessLayout>

                </div>
            </>
        </AppLayout>
    )
}

export default ProcessByFolderView